import { UserState, User } from "@/store/type";

export default {
  state: {
    user: null,
    uid: 0,
  },
  getters: {
    user: (state: UserState) => state.user,
    uid: (state: UserState) => state.uid,
  },
  mutations: {
    setUser(state: UserState, value: User | null) {
      state.user = value;
    },
    setUid(state: UserState, value: number) {
      state.uid = value;
    },
  },
  actions: {},
};
